export default {
  variants: {
    lightGreen: {
      filledTrack: {
        bg: 'green.solid',
      },
    },
  },
}
